import api from "../../config/client.axios.api";

export const getStoreOfAccountApiRequest = async () => {
  const response = await api.get(`/store/store-of-account`);
  return response.data;
};
